<script setup lang="ts">
import { ref, watchEffect } from "vue";

const emit = defineEmits(["change", "update:modelValue"]);

const props = defineProps<{
  label: string;
  value: boolean;
  position?: "left" | "right";
}>();

const internalValue = ref(false);

function toggle() {
  internalValue.value = !internalValue.value;
  emit("change", internalValue.value);
  emit("update:modelValue", internalValue.value);
}

watchEffect(() => {
  internalValue.value = props.value;
});
</script>

<template>
  <section class="base-switch" :class="[position ?? 'left']">
    <div
      class="switch"
      :class="{
        active: internalValue,
      }"
      @click="toggle()"
    >
      <div class="box" />
    </div>

    <template v-if="props.label">
      <label class="label" @click="toggle()">
        {{ props.label }}
      </label>
    </template>
  </section>
</template>

<style lang="scss" scoped>
.base-switch {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;

  &.left {
    flex-direction: row;
    justify-content: flex-start;
  }

  &.right {
    flex-direction: row-reverse;
    justify-content: flex-end;
  }

  .label {
    font-size: 1rem;
    cursor: pointer;
  }

  .switch {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 2.4rem;
    height: 1.1rem;
    background: #ccc;
    border-radius: 2rem;

    .box {
      width: 1.4rem;
      height: 1.1rem;
      background: #a1a1a1;
      border-radius: 2.4rem;
    }

    &.active {
      justify-content: flex-end;

      .box {
        background: #000;
      }
    }
  }
}
</style>
